import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65439d30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "choose-amazon-sku" }
const _hoisted_2 = { class: "choose-amazon-item" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "text" }
const _hoisted_5 = { class: "choose-amazon-item" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "text" }
const _hoisted_8 = { class: "choose-amazon-sku-tool-content" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "flex sku-item-content" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sku-item-radio" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "radio" })
], -1))
const _hoisted_12 = {
  key: 0,
  class: "sku-item-info"
}
const _hoisted_13 = { class: "sku-item-msku" }
const _hoisted_14 = { class: "sku-item-name line--2" }
const _hoisted_15 = {
  key: 1,
  class: "sku-item-info"
}
const _hoisted_16 = { class: "sku-item-msku" }
const _hoisted_17 = { class: "sku-item-name line--2" }
const _hoisted_18 = {
  key: 1,
  class: "no-data"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/no_data_2b.png",
  alt: ""
}, null, -1))
const _hoisted_20 = {
  key: 0,
  style: {"height":"220px"}
}

import { t } from '@/plugins/i18n'
import { ref, computed } from 'vue'
import Search from '../../CreateApiAssociated/components/Search.vue'
import { amazonGet, bindAmazonSku } from '@/apis/inShipping'
import { getSkuCrossMallProductListApi } from '@/apis/stock'
import { ElMessage } from 'element-plus'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  emits: ['getSku'],
  setup(__props, { emit: emits }) {


const store = useStore()
const isCrossMall = computed(() => store.getters.isCrossMall)
const keyword = ref('')
const visible = ref(false)
const searchLoading = ref(false)
const mskuList: any = ref([])
const activeSku = ref({})
const search = () => {
  if (searchLoading.value) return
  if (!keyword.value) {
    choose({})
    visible.value = false
    ElMessage.warning(isCrossMall.value ? t('请搜索需要绑定的CROSS MALL sku') : t('请搜索需要绑定的Amazon sku'))
    return
  }
  searchLoading.value = true
  const api = isCrossMall.value ? getSkuCrossMallProductListApi : amazonGet
  const params = isCrossMall.value ? {
    crossMallProductSku: keyword.value,
    customerShopId: store.getters.curShop
  } : {
    amazonMsku: keyword.value,
    customerShopId: store.getters.curShop
  }
  api(params).then((res: any) => {
    console.log(res)
    if (res.success) {
      if (res.data && res.data.length > 0) {
        visible.value = true
        mskuList.value = res.data
      } else {
        ElMessage.warning(isCrossMall.value ? t('请输入正确的CROSS MALL sku') : t('请输入正确的Amazon sku'))
        visible.value = true
        mskuList.value = []
      }
    }
  }).finally(() => { searchLoading.value = false })
}
const choose = (item: any) => {
  activeSku.value = item
  emits('getSku', item)
}

return (_ctx: any,_cache: any) => {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('平台')) + ":", 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(isCrossMall) ? 'CROSS MALL' : 'Amazon'), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(isCrossMall) ? 'CROSS MALL' : 'Amazon') + " sku:", 1),
      _createElementVNode("span", _hoisted_7, [
        _createVNode(_component_el_tooltip, {
          visible: visible.value,
          "popper-class": "choose-amazon-sku-tool"
        }, {
          content: _withCtx(() => [
            _withDirectives(_createElementVNode("div", _hoisted_8, [
              (mskuList.value.length > 0)
                ? (_openBlock(), _createBlock(_component_el_scrollbar, {
                    key: 0,
                    height: "205px"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mskuList.value, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass(["sku-item", { active: _unref(isCrossMall) ? activeSku.value.productSku === item.productSku : activeSku.value.amazonMsku === item.amazonMsku }]),
                          key: item.amazonMsku,
                          onClick: ($event: any) => (choose(item))
                        }, [
                          _createElementVNode("div", _hoisted_10, [
                            _hoisted_11,
                            (_unref(isCrossMall))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _createElementVNode("div", _hoisted_13, " CROSS MALL sku：" + _toDisplayString(item.productSku), 1),
                                  _createElementVNode("div", _hoisted_14, _toDisplayString(item.productName), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                  _createElementVNode("div", _hoisted_16, " Amazon sku：" + _toDisplayString(item.amazonMsku), 1),
                                  _createElementVNode("div", _hoisted_17, _toDisplayString(item.productName), 1)
                                ]))
                          ])
                        ], 10, _hoisted_9))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("div", null, _toDisplayString(_unref(t)('暂无数据')), 1)
                  ]))
            ], 512), [
              [_directive_loading, searchLoading.value]
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(Search, {
              value: keyword.value,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((keyword).value = $event)),
              onSearch: search,
              placeholder: _unref(isCrossMall) ? _unref(t)('请输入要绑定的CROSS MALL sku') : _unref(t)('请输入要绑定的Amazon sku')
            }, null, 8, ["value", "placeholder"])
          ]),
          _: 1
        }, 8, ["visible"])
      ])
    ]),
    (visible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_20))
      : _createCommentVNode("", true)
  ]))
}
}

})